$('.sidebar-filter a.subfilters').click(function(e) {
    e.preventDefault();
    $(this).next('.sub-filters').toggle();
    return false;
});

$('.sidebar-filter.dropdown h3').click(function(e) {
    $(this).parent().toggleClass("open");
});